module.exports = __webpack_public_path__ + "assets/img/zpimg6.f510e8af.png";